import { useEffect } from 'react';
import { useAppDispatch, useAppState } from '@/store';
import {
  getGoogleMerchantSyncRuns,
  selectGoogleMerchantSyncIsLoading,
  selectGoogleMerchantSyncRuns,
  selectGoogleMerchantSyncRunsPagination,
} from '../feature';

export const useGetGoogleMerchantSyncRuns = (channelSlug?: string) => {
  const dispatch = useAppDispatch();
  const syncRuns = useAppState(selectGoogleMerchantSyncRuns);
  const pagination = useAppState(selectGoogleMerchantSyncRunsPagination);
  const isLoading = useAppState(selectGoogleMerchantSyncIsLoading);
  const error = useAppState(selectGoogleMerchantSyncIsLoading);

  useEffect(() => {
    if (channelSlug) {
      dispatch(getGoogleMerchantSyncRuns({ channelSlug, pageSize: 10, page: 1 }));
    }
  }, [dispatch, channelSlug]);

  return { syncRuns, pagination, isLoading, error };
};
